import { tmWithInterpolation } from '@/config/i18n.ts'
import { useI18n } from 'vue-i18n'
import type { UseI18nOptions } from 'vue-i18n'

export function useSduiI18n(options: UseI18nOptions = { useScope: 'global' }) {
  const i18n = useI18n(options)

  return {
    ...i18n,
    tm: tmWithInterpolation,
  }
}
